import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ConfirmDialogProvider } from './components/NmConfirmDialog';
import { ToastProvider } from './context/ToastContext';
import { I18nRoot } from './bootstrap/I18nRoot';
import { runPwaBuildRecovery } from './bootstrap/pwaBuildRecovery';
import './styles/tokens.css';
import './styles/global.css';
import './styles/slide-up-motion.css';
import './styles/neumorphic.css';
import './styles/register-wizard.css';
import './styles/connections-panel.css';
import './styles/readiness-widget.css';
import './styles/rtl.css';
import './styles/mobile-shell.css';
import './styles/mobile-screens.css';
import './styles/comparison-mobile.css';
import './styles/comparison-batch.css';
import './styles/workout-builder-mobile.css';
import './styles/workout-form.css';
import './styles/touch-first.css';
import './styles/pwa-install.css';
import './styles/coach-peak-trends.css';
import './styles/shared-mobile-tabs.css';
import { installMobileTabVisibility } from './bootstrap/mobileTabVisibility';
import { installPreventPagePinchZoom } from './utils/preventPagePinchZoom';
import { initializeTheme } from './context/ThemeContext';

installPreventPagePinchZoom();
installMobileTabVisibility();
initializeTheme();

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const rootEl: HTMLElement = container;

async function mountApp() {
  await runPwaBuildRecovery();

  createRoot(rootEl).render(
    <React.StrictMode>
      <I18nRoot>
        <ErrorBoundary>
          <ConfirmDialogProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </ConfirmDialogProvider>
        </ErrorBoundary>
      </I18nRoot>
    </React.StrictMode>,
  );
}

void mountApp();
